import { requestAndParse, requestSuccessful } from '../request';

const addAdminNote = async (userId: number, note: string) => {
    const route = 'admin/add-admin-note';
    const payload = {
        userId,
        note,
    };

    const response = await requestAndParse(route, payload);

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default addAdminNote;
